import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const unArriveBooking = async (id: string) => {
  const resp = await api.put(`/bookings/${id}/un-arrive`);
  queryClient.invalidateQueries(["bookings"]);
  queryClient.invalidateQueries(["messages"]);
  return resp;
};
